import React, { useState } from "react";
import { connect } from "react-redux";
import DefaultMap from "components/maps/DefaultMap";
import PageHeader from "components/layout/page-header/PageHeader";
import "./OrderQuote.css";

const OrderQuote = () => {
  const [center] = useState({ lat: 45.9432, lng: 24.9668 });
  const [zoom] = useState(5);

  return (
    <div className="d-flex flex-column order-quote-page">
      <PageHeader
        title="Solicitar serviço"
        subtitle="Envie uma solicitação de orçamento para novos projetos e serviços."
        accent="Marketplace"
      />

      <div className="order-quote-content flex-grow-1">
        <div className="roe-card-style order-quote-card">
          <div className="roe-card-body order-quote-card-body">
            <DefaultMap center={center} zoom={zoom} />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(OrderQuote);

